var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('video',{attrs:{"playsinline":"","autoplay":"","muted":"","loop":"","poster":"/images/poster.png"},domProps:{"muted":true}},[_c('source',{attrs:{"src":"images/bg.webm","type":"video/webm"}}),_vm._v(" "),_c('source',{attrs:{"src":"images/bg.mp4","type":"video/mp4"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-57a2a832","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Video.vue
// module id = null
// module chunks = 